module.exports = __webpack_public_path__ + "static/media/case5B.1a131c2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case5B.mp4
// module id = MMsn
// module chunks = 0